import { render, staticRenderFns } from "./TeachList.vue?vue&type=template&id=3f148abb&"
import script from "./TeachList.vue?vue&type=script&lang=js&"
export * from "./TeachList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports